enum ETypeOfBusiness {
  COMPANY = 'company',
  INDIVIDUAL = 'individual',
}

export default ETypeOfBusiness;
